/**
 * A camera glyph for scan affordances (field feedback 5).
 *
 * The tap that opens the serial sheet, and the button inside it that starts the camera, both read
 * as generic buttons — the words said "scan" but nothing *looked* like a camera, and the feedback
 * from the device walkthrough was that technicians did not realise tapping would let them scan.
 *
 * An inline SVG rather than an emoji or generated-content glyph: emoji rendering varies wildly by
 * platform and is always full-colour (so it cannot follow `currentColor`, which every button here
 * relies on for forced-colors and disabled states), and CSS `content` glyphs are invisible to this
 * repo's css-contract reasoning about what a component emits.
 *
 * Strictly decorative: `aria-hidden`, no title, no role. The accessible name of whatever button
 * carries it must keep coming from the button's own text — the glyph adds affordance for a sighted
 * technician and NOTHING for a screen reader, which already hears "Scan…".
 */
export function CameraGlyph(): JSX.Element {
  return (
    <svg
      className="cap-glyph"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="22"
      height="22"
    >
      <path
        fill="currentColor"
        d="M9.4 4a1 1 0 0 0-.83.44L7.46 6.1H4a2 2 0 0 0-2 2V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8.1a2 2 0 0 0-2-2h-3.46l-1.11-1.66A1 1 0 0 0 14.6 4H9.4zM12 8.6a4.4 4.4 0 1 1 0 8.8 4.4 4.4 0 0 1 0-8.8zm0 2a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8z"
      />
    </svg>
  );
}
